import React, { Component } from 'react';
import Switch from '../../Shared/Switch';
import { isMobile } from '../../helpers/utils';
import '../../Shared/Category/style.css';
import '../../Shared/Category/mobileStyles.css';

class Category extends Component {
    constructor(props) {
        super(props);
       
        this.state = {
            enabled: props.alertRegistrations.length > 0          
        }
    }

    render() {

        const { header, items, alertRegistrations, accountNumber, typeName, isEnabled  , ammount } = this.props;
        const filteredItems = items && items.filter(s => s.isVerified);

        return (
            <div className={isMobile() ? `mobile-font-family comp-category mobile-comp-category` : `comp-category`}>
                <div className={isMobile() ? `mobile-comp-category mobile-comp-category-heading` : `comp-category-heading`}>
                    {isMobile() ? <h3 className="mobile-font-family mobile-category ">{header}</h3> : <h2>{header}</h2>}
                    {isMobile() ? <h3 className="sr-only">{header}</h3> : <h2 className="sr-only">{header}</h2>}                  

                </div>


                <div className="comp-category-container">
                    {
                        filteredItems.map((item, i) => (                           
                            <div className="comp-category-container-row" key={i}>
                                <div className="row-name-block">
                                    <span className="sr-only">{`${header} ` + (i + 1)}</span>
                                    <div className="row-name">{item.displayValue || item.address}</div>
                                </div>
                                <div id={header + ` ` + i + item.address} className="row-control">
                                    <Switch
                                        readValue={item.address}
                                        category={header}
                                        enabled={
                                            isEnabled(alertRegistrations, item.id).length > 0
                                        }
                                        onClick={
                                            () => {
                                                let alertCriteria = []
                                               
                                                const alertReg = alertRegistrations.find(s => s.deliveryMethod === item.id) || {}

                                                if (isEnabled(alertRegistrations, item.id).length > 0) {
                                                    this.props.removeAlertRegistration(alertReg.id, accountNumber, typeName);
                                                } else {
                                                    alertCriteria = [{ type: "Amount", value: ammount || 0 }];
                                                    this.props.addAlertRegistration(item.id, accountNumber, alertCriteria, typeName);
                                                }
                                            }
                                        }
                                        isVerified={item.isVerified}
                                    />
                                </div>
                            </div>
                        ))
                    }
                    {filteredItems.length === 0 && <div className="italic">

                        {header === "Push Notification" && "No devices found"}

                        {header === "Email" && "No email found"}

                        {header === "Text Message" && "No Phone Numbers found"}

                    </div>}
                </div>
            </div>
        )
    }
};

export default Category;
